import { action } from 'typesafe-actions';

import { CollapseTypes, CollapseInterface } from './types';

// Drawer
export const setToggleCollapse = (payload: {
  collapseList: CollapseInterface[];
}) => action(CollapseTypes.SET_TOGGLE_COLLAPSE, payload);
